import React from 'react';
import ProductDescription from './components/ProductDescription';
import SectionContainer from '../../components/SectionContainer';
const ProductInformationSection = () => {
  return <SectionContainer headerTitle="Product Information" data-sentry-element="SectionContainer" data-sentry-component="ProductInformationSection" data-sentry-source-file="ProductInformationSection.tsx">
      <ProductDescription data-sentry-element="ProductDescription" data-sentry-source-file="ProductInformationSection.tsx" />
      {/* <ProductFeatures /> */}
    </SectionContainer>;
};
export default ProductInformationSection;